<!-- 会议活动 -->
<template>
  <div class="act-view">
    <div class="act-card" v-for="item in dataList" :key="item.vid" @click="clickCard(item)">
      <img class="card-bg-img" :src="item.bgimg"/>
      <div class="card-text">
        <div>{{item.title}}</div>
        <div>{{item.date}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import jrConfig from '../../config/jinrong.js'
import pageContent from '../../config/pageContent.js'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dataList: jrConfig.conference,
      pageContent: pageContent
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    clickCard(item) {
      if (item.urlType == 'INH5') {
        // 项目内跳转
        this.$router.push({
          path: '/conferencelist'
        })
      }
      if (item.urlType == 'URL') {
        // 跳转URL
        window.location.href = item.url;
      }
      if (item.urlType == 'TOPATH') {
        // 跳转内部path
        // console.log(item, 'sdf')
        this.$router.push({
          path: item.url,
          query: {
            t: Date.now()
          }
        })
      }
      
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.dataList = this.pageContent['mianliao']['map']
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    document.title = '面料导航';
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.act-view {
  padding: 15px;
}
.act-card {
  margin-bottom: 15px;
  position: relative;
}
.card-bg-img {
  width: 100%;
}
.card-text {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0%;
  height: 100%;
  display: flex;
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FAFAFA;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
}
</style>
